import { useCallback } from "react";

import { ButtonProps as MUIButtonProps } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

import { Container, ContentWrapper, LoadingWrapper } from "./Button.styles";
import { ButtonProps } from "./Button.types";
import Typography from "../Typography/Typography";

const Button: React.FC<ButtonProps> = ({
  children,
  size = "medium",
  variant = "contained",
  color = "primary",
  loading,
  disabled,
  useTypography,
  typographyProps,
  ...innerProps
}) => {
  const renderChildren = useCallback(() => {
    switch (size) {
      case "sm":
      case "md": {
        return (
          <Typography
            type="TextSM"
            fontWeight={600}
            disabled={disabled}
            {...typographyProps}
          >
            {children}
          </Typography>
        );
      }
      case "lg":
      case "xl": {
        return (
          <Typography
            type="TextMD"
            fontWeight={600}
            disabled={disabled}
            {...typographyProps}
          >
            {children}
          </Typography>
        );
      }
      case "2xl": {
        return (
          <Typography
            type="TextLG"
            fontWeight={600}
            disabled={disabled}
            {...typographyProps}
          >
            {children}
          </Typography>
        );
      }
      default:
        return children;
    }
  }, [children, disabled, size, typographyProps]);

  return (
    <Container
      color={color}
      size={size as unknown as MUIButtonProps["size"]}
      variant={variant}
      loading={loading}
      disabled={loading || disabled}
      {...innerProps}
    >
      {loading ? (
        <LoadingWrapper>
          <CircularProgress size={16} color="inherit" />
        </LoadingWrapper>
      ) : null}
      <ContentWrapper loading={loading}>
        {useTypography ? renderChildren() : children}
      </ContentWrapper>
    </Container>
  );
};

export default Button;
